import { render, staticRenderFns } from "./PreAssessment.vue?vue&type=template&id=482108b4&scoped=true"
import script from "./PreAssessment.vue?vue&type=script&lang=js"
export * from "./PreAssessment.vue?vue&type=script&lang=js"
import style0 from "./PreAssessment.vue?vue&type=style&index=0&id=482108b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482108b4",
  null
  
)

export default component.exports